export default __webpack_public_path__ + "static/media/references__marplive.732bf280.jpg";